module.exports = __webpack_public_path__ + "89da279ae64456d082f50e5317131000.pdf";